<template>
  <v-toolbar dense flat light :color="color">
    <v-toolbar-title>{{ title }}</v-toolbar-title>
    <slot></slot>
  </v-toolbar>
</template>

<script>
export default {
  name: 'CardToolbar',
  props: {
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'grey lighten-5',
      required: false,
    },
  },
};
</script>
